/**
 * Comfort Rating Badge
 * Hidden by default. Reveals the badge the first time a shopper clicks a
 * model or variant option in the Single/Dual bundle, ComfortSet, universal
 * product option, or native product-variants selectors, then stays visible
 * for the rest of the session.
 */
(() => {
  const REVEAL_SELECTOR = [
    ".single-dual-bundle__model-option",
    ".single-dual-bundle__type-option",
    ".comfortset-selector__model-option",
    ".comfortset-selector__style-option",
    ".comfortset-selector__diameter-option",
    ".universal-option-selector__option",
    "product-variants",
  ].join(", ");

  const revealBadges = () => {
    const badges = document.querySelectorAll("[data-comfort-rating-badge]");
    if (!badges.length) return false;

    badges.forEach((badge) => {
      badge.hidden = false;
    });

    return true;
  };

  const init = () => {
    if (!document.querySelector("[data-comfort-rating-badge]")) return;

    const handleReveal = (event) => {
      if (!event.target.closest(REVEAL_SELECTOR)) return;
      if (revealBadges()) {
        document.removeEventListener("click", handleReveal, true);
      }
    };

    // Registered on the capture phase: the bundle selector's own click
    // handler calls stopPropagation() on the container (capture phase too),
    // which would otherwise stop this from ever reaching a bubble listener.
    // Capture on document fires before that container handler runs.
    document.addEventListener("click", handleReveal, true);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
